export default {
    done: require('./icons-ok-done.svg'),
  };
  